<!--
 * @Author: Huangjiajia
 * @Description: 框架
 * @Date: 2025-02-05 15:05:24
 * @LastEditors: hjj
 * @LastEditTime: 2025-06-05 09:53:23
 * @FilePath: /beiye_project/src/App.vue
-->
<template>
  <div id="app">
    <div class="top">
      <div class="top_content_box">
        <div class="img_logo_box">
          <img src="@/assets/images/logo.jpg" alt="" class="top_img" />
          <h2>广西万通供应链服务有限公司</h2>
        </div>
        <div class="navTab_box">
          <ul class="navTab">
            <li
              v-for="(e, i) in nav"
              :key="i"
              @click="clickHandle(e, i)"
              :class="navIndex == e.id ? 'tabClass' : ''"
            >
              {{ e.name }}
            </li>
          </ul>
          <a
            href="https://mall.wtdlsc.com/addons/yun_shop/?menu#/downloadUpdate?i=4"
          >
            <div class="login_btn">立即下载</div>
          </a>
        </div>
      </div>
    </div>
    <div class="contact-top">
      <div class="btn" v-if="!isShowConsult" @click="shouConslut">
        <img src="@/assets/images/lianxikefu.png" alt="" />
        <div class="btn-font">联系客服</div>
      </div>

      <div
        class="btn"
        @click="backTop"
        v-if="scrollHeight > 50 && !isShowConsult"
      >
        <img src="@/assets/images/huidaodingbu.png" alt="" />
        <div class="btn-font">回到顶部</div>
      </div>
    </div>
    <!-- 咨询弹窗 -->
    <div class="consultPop" v-if="isShowConsult">
      <consultPop @closePop="isShowConsult = false"></consultPop>
    </div>
    <div class="main">
      <router-view />
    </div>
    <div class="footer-box">
      <div class="footer-top">
        <div class="left">
          <div class="left-content">
            <div class="card" v-for="(item, index) in footerNav" :key="index">
              <div class="title">{{ item.title }}</div>
              <div class="title-samll" v-for="(e, i) in item.list" :key="i">
                <a :href="e.url" v-if="e.isUseA"> {{ e.name }} </a>
                <div v-else @click="clickFooter(e)">{{ e.name }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer-bottom">
        <img src="@/assets/icon/beian-icon.png" alt="" target="blank" />
        <p>Copyright © 广西万通供应链服务有限公司 版权所有</p>
        <p>
          ICP备案/许可证号：桂ICP备<a href="http://beian.miit.gov.cn"
            >2024042275</a
          >号-1
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import consultPop from "@/components/consult.vue";
export default {
  name: "App",
  components: {
    consultPop,
  },
  data() {
    return {
      navIndex: 0,
      nav: [
        {
          id: 0,
          name: "首页",
          url: "/",
        },
        {
          id: 1,
          name: "业务",
          url: "/business",
        },
        {
          id: 4,
          name: "关于我们",
          url: "/about",
        },
      ],
      isShowConsult: false, //是否显示咨询窗口
      footerNav: [
        {
          title: "产品服务",
          list: [
            // {
            //   name: "产品介绍",
            //   url: "",
            //   isUseA: false,
            // },
            // {
            //   name: "解决方案",
            //   url: "",
            //   isUseA: false,
            // },
            {
              name: "立即下载",
              url: "https://mall.wtdlsc.com/addons/yun_shop/?menu#/downloadUpdate?i=4",
              isUseA: true,
            },
            // {
            //   name: "立即登录",
            //   url: "https://mall.wtdlsc.com/admin.html",
            //   isUseA: true,
            // },
          ],
        },
        // {
        // title: "资源中心",
        // list: [
        // {
        //   name: "电子合同百科",
        //   url: "",
        //   isUseA: false,
        // },
        // {
        //   name: "用户指南",
        //   url: "",
        //   isUseA: false,
        // },
        // {
        //   name: "操作视频",
        //   url: "",
        //   isUseA: false,
        // },
        // {
        //   name: "帮助中心",
        //   url: "",
        //   isUseA: false,
        // },
        // ],
        // },
        {
          title: "关于我们",
          list: [
            {
              name: "公司介绍",
              url: "/about",
              isUseA: false,
            },
            {
              name: "联系我们",
              url: "/about",
              isUseA: false,
            },
          ],
        },
        {
          title: "联系我们",
          list: [
            {
              name: "电话：6210088",
              url: "",
              isUseA: false,
            },
            {
              name: "地址：广西壮族自治区南宁市武鸣区城厢镇标营社区富鸣路7号大世界碧贵园1号楼7号商铺前铺",
              url: "",
              isUseA: false,
            },
          ],
        },
      ],
      scrollHeight: 0,
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  watch: {
    $route(val) {
      let a = this.nav.findIndex((url) => url.url == val.path);
      this.navIndex = this.nav[a].id;
    },
  },
  methods: {
    clickHandle(e, i) {
      this.navIndex = e.id;
      if (e.url && this.$route.path != e.url) {
        this.$router.push({
          path: e.url,
        });
      }
    },
    shouConslut() {
      this.isShowConsult = true;
    },
    backTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    handleScroll() {
      this.scrollHeight = window.scrollY || document.documentElement.scrollTop;
    },
    clickFooter(item) {
      if (item.url && this.$route.path != item.url) {
        this.$router.push({
          path: item.url,
        });
      }
    },
  },
};
</script>

<style lang="scss">
#app {
  width: 100%;
  height: 100%;
  flex-direction: column;
  font-family: "PingFang SC";
}
.top {
  width: 100%;
  height: 74px;
  position: fixed;
  top: 0;
  left: 0;
  background-color: #fff;
  z-index: 99;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.08);
  box-sizing: border-box;
  overflow: hidden;
  .img_logo_box {
    display: flex;
    align-items: center;
    h2 {
      padding-left: 20px;
    }
  }
  .top_content_box {
    width: 80%;
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 auto;
  }
  .top_img {
    width: 40px;
    height: 40px;
  }
  .navTab_box {
    display: flex;
  }
  .navTab {
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    .tabClass {
      font-weight: bold;
      border-bottom: 2px solid #00a2ff;
    }
    li {
      font-size: 16px;
      color: #000;
      cursor: pointer;
      margin-right: 50px;
      padding-bottom: 6px;
    }
    li:nth-child(1) {
      margin-left: 30px;
    }
    li:nth-last-child(1) {
      margin-right: 0;
    }
    li:nth-last-child(1) {
      margin-right: 0;
    }
    li:hover {
      font-weight: bold;
    }
  }
  .login_btn {
    color: #fff;
    background-color: #00a2ff;
    border-radius: 5px;
    width: 150px;
    padding: 10px 0;
    cursor: pointer;
    margin-left: 50px;
    text-align: center;
  }
}
.contact-top {
  position: fixed;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  z-index: 99;
  .btn {
    border-radius: 10px;
    background-color: #7ec0fe;
    cursor: pointer;
    margin: 10px 0;
    padding: 20px 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    img {
      width: 36px;
      height: 36px;
    }
    .btn-font {
      font-size: 16px;
      color: #fff;
      margin-top: 6px;
    }
  }
}
.consultPop {
  position: fixed;
  right: 35px;
  top: 50%;
  transform: translate(20px, -50%);
  z-index: 1999;
}
.main {
  padding-top: 74px;
  width: 100%;
}
.footer-box {
  width: 100%;
  height: 388px;
  background-image: url("./assets/images/footer-bg.png");
  background-position: left;
  background-size: cover;
  color: #fff;
  .footer-top {
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    overflow: hidden;
    padding: 30px 0 20px 0;
    .left {
      // border-right: 1px solid #ccc;
      margin: 30px 0;
      flex: 3;
      display: flex;
      justify-content: start;
      .left-content {
        width: 100%;
        display: flex;
        .card {
          flex: 1;
          margin-right: 30px;
          .title {
            padding-bottom: 15px;
            display: inline-block;
            border-bottom: 2px solid #fff;
            margin-bottom: 30px;
            cursor: pointer;
          }
          .title-samll {
            font-size: 14px;
            line-height: 28px;
            cursor: pointer;
            a {
              color: #fff;
            }
          }
        }
      }
    }
  }
  .footer-bottom {
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    p {
      margin: 0 6px;
      a {
        color: #fff;
      }
    }
  }
}
</style>
